<div *ngIf="isLoading | async" class="loading-overlay">
  <p-progressSpinner></p-progressSpinner>
</div>
